import { connect } from 'react-redux';
import { toggleEliteConfirmation } from 'pap/ducks/workflow';
import PackageSelector from 'pap/components/common/input_fields/package_selector';

export default connect(() => ({}), {
  onToggleEliteConfirmation: toggleEliteConfirmation
})(PackageSelector);



// WEBPACK FOOTER //
// ./pap/containers/common/input_fields/package_selector.js